/**
 * Created by pmnia on 7/1/15.
 */
(function () {
    var app = angular.module('appClinicNoParams');
    app.config(['$stateProvider', '$locationProvider', 'DOMAIN_UI', '$ocLazyLoadProvider', '$urlRouterProvider',
        function ($stateProvider, $locationProvider, DOMAIN_UI, $ocLazyLoadProvider, $urlRouterProvider) {

            var config = {
                docTitle: undefined,
                resolveAlways: {},
                parent: 'layout'
            };

            // $urlRouterProvider.when('/', '/fr/t/3');

            // with lazy loading
            $stateProvider

                .state('clinicMaster', {
                    abstract: true,
                    // url: '/:cId',
                    url: '',
                    controller: 'ClinicMasterController',
                    controllerAs: 'vm',
                    parent: config.parent,
                    title: 'clinicMaster',
                    data: {
                        home: 'clinic'
                    },
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./clinicMaster/clinicMaster.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./clinicMaster/clinicMaster.module.js');
                                require('./clinicMaster/clinicMaster.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.clinicMaster'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_footer: /*@ngInject*/function(dataservice, $stateParams){
                            return dataservice.page.getFooterContent($stateParams.cId);
                        }
                    }
                })

                .state('therapist', {
                    parent: 'clinicMaster',
                    url: '/t/:tId',
                    controller: 'TherapistController',
                    controllerAs: 'vm',
                    title: 'therapist',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Therapist'
                    },
                    obtVid: 1,
                    obtPage: 2,
                    logoutState: 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = (DOMAIN_UI.mode == 2)
                                ? require('html!./therapist/clinic.html')
                                : require('html!./therapist/therapist.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./therapist/therapist.module.js');
                                require('./therapist/therapist.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.therapist'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_profile: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);

                        },
                        data_calendar: /*@ngInject*/function(module, dataservice, $stateParams){
                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
                        }
                    }
                })

                .state('clinic', {
                    parent: 'clinicMaster',
                    url: '',
                    controller: 'ClinicController',
                    controllerAs: 'vm',
                    title: 'clinic',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Clinic'
                    },
                    obtVid: 1,
                    obtPage: 1,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./clinic/clinic.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./clinic/clinic.module.js');
                                require('./clinic/clinic.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.clinic'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        calendarProfile: /*@ngInject*/function (module, dataservice, $stateParams) {
                            return dataservice.calendar.getProfile($stateParams.cId);
                        },
                        data_clinic: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            return dataservice.clinic.getClinic($stateParams.cId)
                        },
                        data_therapists: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            return dataservice.clinic.getTherapists($stateParams.cId);
                        }
                    }
                })

                .state('preference', {
                    parent: 'clinicMaster',
                    url: '/p/:uId',
                    controller: 'PreferenceController',
                    controllerAs: 'vm',
                    title: 'preference',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Preference'
                    },
                    obtVid: 1,
                    obtPage: 3,
                    logoutState: 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./preference/preference.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./preference/preference.module.js');
                                require('./preference/preference.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.preference'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }]
                    }
                })

                .state('history', {
                    parent: 'clinicMaster',
                    url: '/h/:uId',
                    controller: 'HistoryController',
                    controllerAs: 'vm',
                    title: 'history',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> History'
                    },
                    obtVid: 1,
                    obtPage: 3,
                    logoutState: 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./history/history.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./history/history.module.js');
                                require('./history/history.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.history'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_history: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
                        }
                    }
                })

                .state('dynamic', {
                    parent: config.parent,
                    url: '/dynamicPage/:cId/:kId',
                    controller: 'DynamicController',
                    controllerAs: 'vm',
                    title: 'dynamic',
                    // data:{
                    //     home: '',
                    // },
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Dynamic'
                    },
                    obtVid: 1,
                    obtPage: 0,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./dynamic/dynamic.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./dynamic/dynamic.module.js');
                                require('./dynamic/dynamic.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.dynamic'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });

                            return deferred.promise;
                        }],
                        data_content: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            return dataservice.dynamic.getContent($stateParams.kId, $stateParams.cId)
                        }
                    }
                })

                //Parent set to clinic
                .state('clinic.service', {
                    //parent: 'therapist',
                    url: '/service/:sId',
                    controller: 'ServiceController',
                    controllerAs: 'vmService',
                    title: 'service',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Service'
                    },
                    obtVid: 1,
                    obtPage: 1,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = (DOMAIN_UI.mode == 2)
                                ? require('html!./service/service_with_banner.html')
                                : require('html!./service/service.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./service/service.module.js');
                                require('./service/service.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.service'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }],
                        data_content: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
                        }
                    }
                })
                //Parent set to therapist
                .state('therapist.service', {
                    //parent: 'therapist',
                    url: '/service/:sId',
                    controller: 'ServiceController',
                    controllerAs: 'vmService',
                    title: 'service',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> Service'
                    },
                    obtVid: 1,
                    obtPage: 2,
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = (DOMAIN_UI.mode == 2)
                                ? require('html!./service/service_with_banner.html')
                                : require('html!./service/service.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./service/service.module.js');
                                require('./service/service.controller.js');
                                $ocLazyLoad.load({
                                    name: 'app.service'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }],
                        data_content: /*@ngInject*/function(module, dataservice, $stateParams, $state){
                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
                        }
                    }
                })

                //resellers report
                .state('resellerBookingReport', {
                    parent: 'clinicMaster',
                    url: '/report/:uId',
                    controller: 'resellerBookingReportCtrl',
                    controllerAs: 'vm',
                    title: 'report',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> report'
                    },
                    obtVid: 1,
                    obtPage: 3,
                    logoutState: 'clinic',
                    templateProvider: ['$q', function ($q) {
                        var deferred = $q.defer();
                        require.ensure([], function () {
                            var template = require('html!./resellers/reports/resellerBookingReport.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    resolve: {
                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                            var deferred = $q.defer();
                            require.ensure([], function () {
                                require('./resellers/resellers.module.js');
                                require('./resellers/reports/resellerBookingReport.controller.js');
                                require('./resellers/directives/resellerBookingReport/resellerBookingReport.directive.js');
                                $ocLazyLoad.load({
                                    name: 'app.resellers'
                                }).then(function () {
                                    deferred.resolve(true);
                                });
                            });
                            return deferred.promise;
                        }],
                        comboOptions: /*@ngInject*/function loadComboBox(dataservice, logger, $stateParams) {
                            var options = [
                                {'id': 10, 'name': 'therapists'}
                            ];
                            var args = {cId: $stateParams.cId || null};

                            return dataservice.form.getOptions(options, {isTool: true}, args)
                                .then(function (result) {
                                    if (result) {
                                        return result;
                                    } else {
                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
                                        return [];
                                    }
                                });
                        }
                    }
                })

        }]);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.clinicNoParams.config.js
 ** module id = 278
 ** module chunks = 0
 **/